import React from 'react'

import Stack from 'app/components/base/Stack'
import SignInHeaderBlock from 'app/components/common/SignInHeaderBlock'
import useAuthStore, { getIsConfirmed } from 'app/store/auth.store'

import ChatButton from '~/components/buttons/ChatButton'
import HeartHeaderButton from '~/components/buttons/HeartHeaderButton'
import MyAccountButton from '~/components/buttons/MyAccountButton'
import MyGarageHeaderButton from '~/components/buttons/MyGarageHeaderButton'

const HeaderUserBlock = () => {
  const isAuth = useAuthStore(getIsConfirmed)

  if (!isAuth) {
    return <SignInHeaderBlock sx={{ display: { xs: 'none', cmd: 'flex' } }} />
  }

  return (
    <Stack
      direction="row"
      spacing={{ lg: 1 }}
      sx={{ display: { xs: 'none', cmd: 'flex' } }}
    >
      <MyAccountButton />

      <ChatButton />

      <MyGarageHeaderButton />

      <HeartHeaderButton />
    </Stack>
  )
}

export default HeaderUserBlock
